// This function updates the price and discount
function updatePriceAndDiscount(variant) {
  var selectedVariantPrice = variantPrices[variant];
  if (selectedVariantPrice) {
    var discountRate;
    if (document.querySelector('.promotion-block.special-discount')) {
      discountRate = 0.20;
    } else if (document.querySelector('.promotion-block.standard-discount')) {
      discountRate = 0.15;
    }

    if (discountRate) {
      var discount_value = selectedVariantPrice * discountRate;
      var sales_price = selectedVariantPrice - discount_value;

      console.log("Updating for Variant:", variant, " | Discount Rate:", discountRate);

      document.querySelector('.savings').textContent = "£" + discount_value.toFixed(2);
      document.querySelector('.discounted-price').textContent = "Discounted Price: £" + sales_price.toFixed(2);
    }
  }
}

// Event listener setup for radio buttons
var radios = document.querySelectorAll('.options-selection__option-value-input');
radios.forEach(function(radio) {
  radio.addEventListener('change', function() {
    var selectedOptions = document.querySelectorAll('.options-selection__option-value-input:checked');
    var variant = Array.from(selectedOptions).map(option => option.value).join(' / ');
    updatePriceAndDiscount(variant);
  });
});

// Initial update for the currently selected variant
var currentVariant = Array.from(document.querySelectorAll('.options-selection__option-value-input:checked')).map(option => option.value).join(' / ');
updatePriceAndDiscount(currentVariant);